import './dashboard';
import './crm';
import './hr';
import './settings';
import './timesheets';
import './quotations';
import './shifts';
import './schedule';
import './subscriptions';
import './skills';
import './customerShifts';
import './documentation';
import './tasks';
import './notes';
import './twinfield';
import './reports';



// WEBPACK FOOTER //
// ./src/app/modules/index.ts